<!--
 * @Description: 
 * @Date: 2022-12-09 11:26:23
-->
<template>
  <div style="width: 300px">
    <el-form :model="ruleForm" ref="ruleForm">
      <el-form-item prop="aspAuditReason">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请填写审核不通过原因（最少5个字）"
          maxlength="50"
          v-model="ruleForm.aspAuditReason"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btnBox" style="margin-top:20px; text-align: center;">
      <el-button type="primary" plain @click="$xrkDialog.remove()">
        取消
      </el-button>
      <el-button
        type="primary"
        :disabled="ruleForm.aspAuditReason.length < 5"
        @click="submit"
      >
        确认
      </el-button>
    </div>
  </div>
</template>
<script>
import { paymentReview } from '@/api/ajax';
export default {
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      ruleForm: {
        aspAuditReason: ''
      }
    };
  },
  methods: {
    submit() {
      paymentReview
        .audit({
          id: this.id,
          aspAuditStatus: 3,
          aspAuditReason: this.ruleForm.aspAuditReason
        })
        .then(() => {
          this.$emit('success');
          this.$xrkDialog.remove();
        });
    }
  }
};
</script>
